import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { IdCard, ArrowRight } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";

const LABEL = { expired: ["Expired", "bg-rose-600 text-white"], due_30: ["30 days", "bg-rose-100 text-rose-700"], due_60: ["60 days", "bg-amber-100 text-amber-700"] };

export function DocExpiryCard({ companyId, isAdmin }) {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { if (companyId) api.get("/compliance/document-expirations", { params: isAdmin ? { company_id: companyId } : {} }).then((r) => setD(r.data)).catch(() => {}); }, [companyId, isAdmin]);
  if (!d || d.count === 0) return null;
  return (
    <Card className={`p-4 sm:p-5 ${d.expired ? "border-rose-300 bg-rose-50/50 dark:bg-rose-500/5" : "border-amber-200 bg-amber-50/40 dark:bg-amber-500/5"}`} data-testid="doc-expiry-card">
      <h3 className={`font-semibold font-display flex items-center gap-2 ${d.expired ? "text-rose-700" : "text-amber-700"}`}><IdCard className="w-4 h-4" /> ID / work permits expiring <span data-testid="doc-expiry-count" className={`text-xs font-mono-num px-1.5 py-0.5 rounded text-white ${d.expired ? "bg-rose-600" : "bg-amber-500"}`}>{d.count}</span></h3>
      <p className="text-xs text-muted-foreground mt-0.5">Ask the employee for a renewed copy, then accept it with the new expiration date.</p>
      <ul className="mt-3 space-y-1 text-sm">
        {d.items.slice(0, 6).map((i) => (
          <li key={i.id} data-testid={`doc-expiry-item-${i.id}`} className="flex justify-between gap-2 border-b border-dashed border-border/60 py-1">
            <span className="truncate"><span className="font-medium">{i.name}</span> · {i.doc_label} · {i.filename}</span>
            <span className="whitespace-nowrap text-xs flex items-center gap-1.5"><span className={`px-1.5 py-0.5 rounded font-semibold ${LABEL[i.state][1]}`}>{LABEL[i.state][0]}</span><span className="text-muted-foreground">{fmtDate(i.expires_on)}</span><Button size="sm" variant="ghost" className="h-6 px-2" data-testid={`doc-expiry-open-${i.id}`} onClick={() => navigate(`/employees?compliance=${i.employee_id}`)}>Open <ArrowRight className="w-3 h-3 ml-1" /></Button></span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
